import {Component, Inject} from '@angular/core';
import {UUID} from '@util/types';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import {ApplicationService} from '@services/application.service';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MarkantElementsModule} from '@markant/elements-angular';
import {MatInput} from '@angular/material/input';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';

export interface ResetApplicationComponentData {
  productId: UUID;
  cycleId: UUID;
}

@Component({
  selector: 'app-reset-application',
  templateUrl: './reset-application.component.html',
  styleUrls: ['./reset-application.component.scss'],
  standalone: true,
  imports: [MatFormField, MatLabel, MarkantElementsModule, MatDialogContent, MatDialogTitle, MatInput, CdkTextareaAutosize, MatDialogActions],
})
export class ResetApplicationComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: ResetApplicationComponentData,
    private readonly matDialogRef: MatDialogRef<object>,
    private readonly applicationService: ApplicationService,
  ) {}

  cancel(): void {
    this.matDialogRef.close();
  }

  send(): void {
    const textarea = document.getElementById('comment') as HTMLTextAreaElement;
    const comment = textarea.value;
    this.applicationService.resetProduct(this.data.productId, this.data.cycleId, comment).subscribe(() => {
      this.matDialogRef.close();
    });
  }
}
